import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门话题</h2>
          <p className="mt-2 text-sm text-foreground-600">当前最受关注的黑料内容话题与讨论方向</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              className="inline-flex items-center gap-2 px-5 py-3 bg-background-100 hover:bg-primary-50 border border-background-200 hover:border-primary-200 rounded-full transition-all cursor-pointer group"
            >
              <span className="w-5 h-5 flex items-center justify-center text-primary-500">
                <i className={`${topic.icon} text-sm`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-500 bg-background-200/70 px-2 py-0.5 rounded-full">
                {topic.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}